// Copyright (c) 2019 Deere & Company

import IncentiveClaims from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';
import {getCombinedClaimTypes} from '../../shared/services/build-claim-types';

const getStateToBindToContainerProps = state => ({
    ...state.claims.incentive,
    allowedAccounts: state.user.details.settings.dealer.accounts.allowedAccounts,
    claimTypes: getCombinedClaimTypes(state.app.claimTypes, state.app.subClaimTypes),
    isCkcCustomerFailed: state.customerFailed.ckcCustomerFailed,
    laborLocations: state.claims.laborLocations,
    laborTypes: state.claims.laborTypes,
    latestPerUnitMeasurements: state.latestPerUnitMeasurements,
    otherCreditDescriptions: state.claims.otherCreditDescriptions,
    partsGroupedByPartNumber: state.claims.partsGroupedByPartNumber,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    warranties: state.productDetails.warranties
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(IncentiveClaims);



// WEBPACK FOOTER //
// ./src/claim/incentive/state-connector.js